import { Event } from '@mui/icons-material';
import { Badge, Chip } from '@mui/material';

import { ExplorableId } from '../../explorable-id';
import { bool, str } from '../field-access';
import type { ResourceDetailSlotProps } from '../types';
import { statusTone } from './status-tone';

/** Encounter identity band, read from the registry record. */
export function EncounterHeader({ data, resourceId, scope }: ResourceDetailSlotProps) {
  const encounter = data;
  const status = str(encounter, 'status');
  const isSigned = bool(encounter, 'is_signed');
  const noteTitle = str(encounter, 'note_title');

  return (
    <div className="bg-white rounded-lg shadow p-6 mb-6">
      <div className="flex items-start justify-between gap-4">
        <div>
          <h1 className="text-2xl font-bold text-gray-900 flex items-center">
            <Event className="mr-2 h-6 w-6" />
            {noteTitle || 'Encounter'}
          </h1>
          <div className="mt-2 flex flex-wrap items-center gap-1.5">
            <ExplorableId
              label="encounter"
              value={resourceId}
              organizationId={scope.organizationId}
            />
          </div>
        </div>
        <div className="flex items-center gap-3 shrink-0">
          {isSigned && <Chip label="Signed" color="success" size="small" />}
          {status && <Badge color={statusTone(status)}>{status}</Badge>}
        </div>
      </div>
    </div>
  );
}
